<template>
  <div class="home">
    <NavTopLink v-if="!isFull" />
    <router-view></router-view>
  </div>
</template>
<script>
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  setup() {
    const route = useRoute();

    const isFull = computed(() => {
      if (route.query && route.query && route.query.isFull === "true") {
        return true;
      } else {
        return false;
      }
    });
    return {
      isFull,
    };
  },
});
</script>
<style lang="less" scoped>
.home {
  width: inherit;
  height: inherit;
}
</style>
